// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceEvaluationPage-cls1_ST7","cls2":"ReferenceEvaluationPage-cls2_2eu ReferenceEvaluationPage-cls1_ST7"};